module.exports = __webpack_public_path__ + "static/img/like-dislike-panel.1e9b5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/like-dislike-panel.png
// module id = 65Lw
// module chunks = 1